import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import style from './style.scss';

const ProgressBar = ({ step = 1, totalStep = 3 }) => (
  <div className={cn('grid-x w-100', style.progressBar)}>
    <div className={cn('cell progress-bar', style['progress-bar'], `small-${4 * step}`)}>
      <span>{`Step ${step} of ${totalStep}`}</span>
    </div>
  </div>
);

ProgressBar.propTypes = {
  step: PropTypes.number,
  totalStep: PropTypes.number,
};

export default ProgressBar;
